import React, { Component, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Amplify, {Auth, Hub} from "aws-amplify";
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-modal';
import _ from 'lodash';
import 'react-toastify/dist/ReactToastify.css';
import { logout, resetupAuth } from "./actions/auth";
import { getDeletedItems, getUpdatedItems } from "./actions/items";
import { APIManager } from "./utils/api";
import { StateMachineManager } from "./utils/stateMachine";
// import PublicRoutes from "./PublicRoutes";
import PrivateRoutes from "./PrivateRoutes";
import MainNavbar from "./components/Navbar";
import { toggleMachine } from "./machines/ToggleMachine";
import { isOnboarding } from "./utils/userState";
import imgCamelLogo from './assets/images/main-logo-white.svg';
import "./App.scss";

// Upload Modal implementation
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import UploadModalContent from "./components/dashboard/UploadModalContent";
const ReactSwal = withReactContent(Swal);

const NavbarBlackRoutes = [
  // '/onboarding',
  '/onboarding/survey',
  '/onboarding/infographics',
  '/onboarding/partner',
  '/onboarding/checklist',
  '/not-found',
  '/upload',
  '/paywall'
];

class App extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      isAuthenticated: props.auth.isAuthenticated,
      user: null,
      current: toggleMachine.initialState
    };

    props.resetupAuth();

    APIManager.Instance.actions['logout'] = props.logout;
    StateMachineManager.Instance.startService();
    StateMachineManager.Instance.setChangeStateHandler(current => this.setState({ current }));
  }

  componentWillUnmount() {
    StateMachineManager.Instance.stopService();
  }

  componentDidMount() {
    // TODO init Auth from saved session (cookie) stage
    Modal.setAppElement(this.el);
    try {
      
      Hub.listen("auth", ({payload: {event, data}}) => {
        switch (event) {
          case "signIn":
          case "cognitoHostedUI":
            const user = Auth.currentAuthenticatedUser();
            break;
            
          case "signOut":
            break;
          case "signIn_failure":
          case "cognitoHostedUI_failure":
            break;
        }
      });

      if (this.props.auth.isAuthenticated) {
        // this.props.resetupAuth();
        const { cognitoUser } = this.props.auth;
        if (isOnboarding(cognitoUser)) {
          this.props.history.push('/onboarding');
        }
        // const customState = _.get(this.props, "cognitoUser.attributes['custom:state']", null);
        // if (!customState || (customState === 'onboarding-01')) {
        //   this.props.history.push('/onboarding/survey');
        // } else if (!customState || (customState === 'onboarding-02')) {
        //   this.props.history.push('/onboarding/infographics');
        // } else if (!customState || (customState === 'onboarding-03')) {
        //   this.props.history.push('/onboarding/checklist');
        // }
      }
      //////
    } catch(e) {
      if (e === 'No current user') {
        toast.error('Can not find the current user.', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  }
  
  setUser = async theUser => {
    this.setState({ user: theUser });
  }

  openUploadModal = (file, path) => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <UploadModalContent
          user={this.props.user}
          cognitoUser={this.props.cognitoUser}
          onClose={ReactSwal.clickCancel}
          file={file}
          Auth={this.props.auth.Auth}
          Analytics={this.props.Analytics}
          items={this.props.items}
          collectionState={this.state.current}
          path={path}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  render() {
    const { isAuthenticated, cognitoUser } = this.props.auth;
    const accountStatus = process.env.REACT_APP_FLAG_BILLING ? _.get(this.props.user, 'accountStatus.status', '') : 'active';
    const isActiveAccount = accountStatus === 'active' || accountStatus === 'trialing';
    const childProps = {
      isAuthenticated,
      setUser: this.setUser,
      openUploadModal: this.openUploadModal,
      accountStatus,
      pathname: _.get(this.props.history, 'location.pathname', '')
    };

    const { pathname } = this.props.history.location;
    
    return (
      // <React.StrictMode>
        <div className="App container">
          {/* <ToastContainer enableMultiContainer containerId={'error'} position={toast.POSITION.TOP_RIGHT} /> */}
          <ToastContainer 
            bodyClassName="cc-toast-body"
            progressClassName="cc-toast-progress"
          />
          {isAuthenticated && (
            <MainNavbar
              user={cognitoUser}
              openUploadModal={this.openUploadModal}
              history={this.props.history}
              className={NavbarBlackRoutes.includes(pathname) ? (pathname === '/paywall' && isActiveAccount ? '' : 'd-none') : '' }
              pathname={pathname}
              collectionState={this.state.current.value}
              collectionEvent={this.state.current.event}
            />
          )}
          <PrivateRoutes childProps={childProps} />
          <div className="main-footer">
            <img src={imgCamelLogo} alt="logo" />
            <ul>
              <li><a target="_blank" rel="noopener noreferrer" href="https://www.contentcamel.io/terms/">Terms of Use</a></li>
              <li><a target="_blank" rel="noopener noreferrer" href="https://www.contentcamel.io/privacy/">Privacy Policy</a></li>
            </ul>

            <div className="copy-right">© 2024 Content Camel, Inc. All rights reserved.</div>
          </div>
        </div>
      // </React.StrictMode>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  cognitoUser: state.auth.cognitoUser,
  Analytics: state.auth.Analytics,
  user: state.auth.tenant,
  items: state.item.items
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  logout,
  resetupAuth,
  getDeletedItems,
  getUpdatedItems
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
